/*
 * (Trello 卡 6aab90b1e1dc16fd9ba865c0, 辉哥 9/17 15:01 拍板)
 * 详情页头图组件
 *
 * 渲染:
 *   - 16:9 头图容器 (.Page-hero-image-wrap)
 *   - .Page-hero-image: img 标签, object-fit cover
 *   - .Page-hero-overlay: 顶部到底部深→浅渐变, 让深色文字清晰
 *   - 标题/badges (vendor DiscussionHero) 容器内 (.Page-hero-content)
 *
 * 使用:
 *   extendDiscussionPage.js override DiscussionPage.prototype.hero, 让 hero 函数:
 *     有图 → 返回 [<DiscussionPageHero discussion={...} />, <DiscussionHero discussion={...} />]
 *     无图 → 返回 vendor 默认 (<DiscussionHero discussion={...} />)
 *   vendor PageStructure 自动包一层 <div className="Page-hero">{hero() || null}</div>
 *   CSS .Page-hero:empty { display: none } 兜底隐藏空容器
 */

import Component from 'flarum/common/Component';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
export default class DiscussionPageHero extends Component {
  init() {
    // 无需 state
  }
  view() {
    const discussion = this.attrs.discussion;
    const heroUrl = discussion.attribute('heroImageUrl');
    if (!heroUrl) return null;
    return m("div", {
      className: "Page-hero-image-wrap"
    }, m("img", {
      className: "Page-hero-image",
      src: heroUrl,
      alt: ""
    }), m("div", {
      className: "Page-hero-overlay"
    }), m("div", {
      className: "Page-hero-content"
    }, m(DiscussionHero, {
      discussion: discussion
    })));
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/DiscussionPageHero', DiscussionPageHero);